import { useTranslation } from 'next-i18next'
import PercentDataBlock from 'blocks/PercentData'

export function PercentData() {
  const { t } = useTranslation('home.page')

  return (
    <PercentDataBlock
      number="89"
      description={t('percentData.description')}
      sources={[
        {
          title: '*Brandgagement - 2023',
          url: '',
        },
        {
          title: '**Comarch x IFOP - 2023',
          url: '',
        },
      ]}
    />
  )
}
